import React from "react";

export default function Footer() {
  return (
    <footer className="mt-12 border-t border-[#E5E7EB] bg-white" data-testid="kostra-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <div className="text-sm text-[#4B5563]">
          <span className="font-display text-[#0A3B24] font-medium">KOSTRA</span>
          <span className="mx-2 text-[#D4AF37]">·</span>
          The Food Costing Expert by Anupam
        </div>
        <div className="text-xs italic text-[#4B5563]" data-testid="footer-attribution">
          This calculator invented by Anupam Prasad — all usage rights reserved.
        </div>
      </div>
    </footer>
  );
}
